<template lang="pug">
  div.payment.accruals-legal-create
    e-modal(
      ref="modalForm"
      @confirm="sendForm()"
      @close="closeForm()"
      title="Сформировать счет на оплату"
      saveBtnLabel="Сформировать"
      :hideDeleteButton="false"
      :centered="true"
      :autoHeight="true"
    )
      slot
        // чтобы список адресов был полнтсью виден
        // убираем скрол и меняем класс формы
        // иначе его конец спрчетсчя за футером
        e-form(
          :formValidator="formValidator"
          :enablePerfectScrollbar="false"
          formClass="fix-elements-overflow-problem"
        )
          div.body
            div.col
              e-form-group(
                inputType="suggestion[]"
                name="legal_ids"
                label="Наименование"
                :model="fields"
                tabView="tab1"
                :suggestionEndpoint="suggestionLegalsEndpoint"
                :transformSuggestions="transformLegalsSuggestions"
                :minSuggestLen="2"
                placeholder="начните вводить название или инн..."
                :required="true"
              )

              e-form-group(
                name="period"
                inputType="calendar"
                label="Период"
                :model="fields"
                tabView="tab1"
                type="month"
                format="MM/yyyy"
                :required="true"
              )

              e-form-group(
                name="create_file"
                inputType="checkbox"
                caption="Сформировать файл счета на оплату"
                :model="fields"
                tabView="tab1"
              ).no-min-height


</template>

<script>
  import {payment, wasteGenerators} from "../../api/api-endpoints"
  import formBaseMixin from '../../components/form/form-base-mixin.js'

  export default {
    mixins: [formBaseMixin],
    data () {
      return {
        fields: {
          legal_ids: [],
          period: '',
          create_file: false
        }
      }
    },
    methods: {
      /**
       * @override
       */
      getSuccessTitle () {
        return null
      },
      getUpdateOrCreateUrl () {
        return payment.accrualsLegalCreate()
      },
      closeForm () {
        this.$refs.modalForm.redirectToPrev()
      },
      suggestionLegalsEndpoint (ctx, selected, q) {
        return wasteGenerators.legals({query: {q, 'per-page': 50, expand: 'accounts'}})
      },
      transformLegalsSuggestions (ctx, data) {
        return data.data.map(item => ({id: item.id, name: `${item.full_name}, ИНН: ${item.inn || '-'}`, item}))
      }
    }
  }
</script>
